import { TaskStateT } from 'pages/Tasks/types'

export const tasks: Record<TaskStateT, string> = { todo: 'todo', pending: 'pending', closed: 'closed' }
export const tasksArray = Object.keys(tasks) as TaskStateT[]
